export default __webpack_public_path__ + "static/delta-05ddf2fc1ad481d79393496b666ebd00.png";